// extracted by mini-css-extract-plugin
export default {"tippyDiv":"MicButton_tippyDiv__E7as1","tippyButton":"MicButton_tippyButton__Om3iT","speakAnimation":"MicButton_speakAnimation__DB+hw","speak":"MicButton_speak__jrQDG"};